import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './SelectedRecord.css';
class SelectedRecord extends Component {
  static propTypes = {
    defaultTitle: PropTypes.string,
    defaultSubTitle: PropTypes.string,
    title: PropTypes.string,
    subTitle: PropTypes.string
  };
  render() {
    const { title, defaultTitle, subTitle, defaultSubTitle } = this.props;
    const titleString = title ? title : defaultTitle;
    const subTitleString = subTitle ? subTitle : defaultSubTitle;

    return (
      <div className="selectedRecordComponent">
        <div className="recordTitle">{titleString}</div>
        <div className="recordSubTitle">{subTitleString}</div>
      </div>
    );
  }
}
export default SelectedRecord;



// WEBPACK FOOTER //
// ./src/Components/SelectedRecord/SelectedRecord.js